//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['conditional'],
    data: function data() {
        return {
            dialog: false,
            title: '',
            alertText: ""
        };
    },

    methods: {
        openModal: function openModal(_ref) {
            var title = _ref.title,
                message = _ref.message;

            this.dialog = true;
            this.title = title;
            this.alertText = message;
        },
        closeModal: function closeModal() {
            this.title = '';
            this.message = '';
            this.dialog = false;
        }
    }

};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collaborators/error-modal.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/collaborators/error-modal.vue
// module chunks = 4